import React from "react";

import { GridOn, GridOff } from "@mui/icons-material";

function ToggleGridIcon({ isGridOn, color = 'white' }) {
    return isGridOn ? <GridOn color={color} /> : <GridOff color={color} />;
}

export default ToggleGridIcon;
